module.exports = __webpack_public_path__ + "img/16262439.b2244bda.png";